if($('.type-detail').length){
    $(document).ready(function() {
        $('.p-to-cart-block').before('<div class="stockCustom"></div>')
        getShoptetDataLayer('product').codes.forEach(function(code) {
            var quantityAtProdejna = 0; // Defaultní množství pro Prodejnu
            if(typeof code.stocks !== 'undefined'){
                code.stocks.forEach(function(stock) {
                    if (stock.id === 16) {
                        quantityAtProdejna = stock.quantity//parseInt(stock.quantity, 10);
                    }
                });            
                if($('#simple-variants').length){
                    var hideClass = 'hide'
                }
                else{
                    var hideClass = ''
                }
                var productInfo = '<div class="customStockInfo '+hideClass+'" data-code="'+code.code+'" data-stock="'+quantityAtProdejna+'">'
                productInfo += '<p><strong>Dostupnost na prodejně</strong></p>'
                productInfo += '<p>Brno: '+quantityAtProdejna+' ks</p>'
                productInfo += '</div>'
                $('.stockCustom').append(productInfo);
            }
        });

    });
}